import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';

/* import CatalogoPersona from '../../catalogos/catalogoPersona';
import CatalogoAgente from '../../catalogos/catalogoAgente'; */
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';



const AgregarConsejo = (props) => {

    const [clase, setClase] = useState('d-flex bluex-bg');
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtNombre = useRef();
    const txtApellido = useRef();
    const [idconsejo, setIdConsejo] = useState(0)
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [activate, setActivate] = useState(false);


    const [url, setUrl] = useState('');

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const [operacion, setOperacion] = useState(0);


    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));



    }, [props.operacion]);


    const blanquear = () => {

        txtNombre.current.value = '';
        txtApellido.current.value = '';
    }


    const cancelar = () => {

        blanquear();

        props.onHideCancela();
    }



    const procesarRegistro = () => {

        let endpoint = `${op.conexion}/api/configuracion/actconsejo`;

        let body = {
            operacion: operacion,
            id: idconsejo,
            idorg: props.idorganizacion,
            cnombre: txtNombre.current.value.trim(),
            capellido: txtApellido.current.value.trim()
        }

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {



                setActivate(false);



                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Operacion Realizada.', icono: 'exito' });

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }


    const onChangeValidar = (e) => {
        e.preventDefault();

        let sigue = true;

        if (txtNombre.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar un Nombre', icono: 'informacion' });
            sigue = false;
            txtNombre.current.focus();

        } else if (txtApellido.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar un Nombre', icono: 'informacion' });
            sigue = false;
            txtNombre.current.focus();

        }

        var datos = {}
        if (sigue) {

            datos = {
                nombreconsejero: txtNombre.current.value,
                apellidoconsejero: txtApellido.current.value
            }

            if (operacion === 3) {

                setMensajesino({ mostrar: true, titulo: 'Notificación', texto: 'Esta Seguro de eliminar Este Registro?', icono: 'informacion' })

            } else {
                procesarRegistro()

            }
        }


    };



    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro()


    };

    const cerrarModal = () => {

        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancela();
        props.renderizar(props.idorganizacion);
    }



    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                console.log(props.idorganizacion)
                if (props.operacion !== 1) {
                    setIdConsejo(props.consejero.idconsejoplanificacion)
                    console.log(props.consejero)
                    console.log(props.operaciones)
                    txtNombre.current.value = props.consejero.nombreconsejero;
                    txtApellido.current.value = props.consejero.apellidoconsejero;

                }

            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className='fw-bold text-light'><h4>{operacion === 1 ? 'Agregar Registro Inmobiliario 2' : operacion === 2 ? 'Modificar Registro Inmobiliario' : operacion === 3 ? 'Eliminar Registro Inmobiliario' : 'Consultar Registro Inmobiliario'}</h4></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflow: 'scroll' }}>

                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='row col-md-12 px-0 mx-auto'>
                    <div className="input-group mb-2 input-group-sm col-sm-12 mx-auto px-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Nombre:</label>
                        <input type="text" className="form-control text-uppercase" autoComplete='off' ref={txtNombre} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id='inputRazonSoc' />
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-12 mx-auto px-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Apellido:</label>
                        <input type="text" className="form-control text-uppercase" autoComplete='off' ref={txtApellido} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id='inputRazonSoc' />
                    </div>

                </div>




            </Modal.Body>
            <Modal.Footer>

                <div className='col-sm-12 d-flex justify-content-center row mx-auto py-1'>
                    <button type="button" ref={btnAcepta} onClick={onChangeValidar} className="col-sm-6 btn-sm btn btn-success rounded-pill"><i className="far fa-check-circle"></i>Aceptar</button>
                    <button type="button" ref={btnCancela} onClick={cancelar} className="col-sm-6 btn-sm btn btn-danger rounded-pill"><i className="fas fa-window-close"></i>Cancelar</button>
                </div>

            </Modal.Footer>
        </Modal>
    );
}
export default AgregarConsejo;